import { AnalyticsBrowser } from '@segment/analytics-next';
import typewriter from './segment';

export const analytics = AnalyticsBrowser.load({
  writeKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY ?? '',
});

typewriter.setTypewriterOptions({
  analytics: analytics,
});
